import { useRef } from "react";
import { useMount } from ".";

type Status = "idle" | "scheduled" | "disabled";

type ScheduleProps = {
  scheduleTime: number;
  onSchedule: () => void;
};

type Scheduler = {
  disableScheduler: () => void;
  status: Status;
};

/**
 *
 * @param scheduleTime - time in milliseconds to schedule the no show
 * @returns { isTrigger, disabledScheduler }
 *
 * @author [Rajkumar Rathod]
 */
export const useScheduleNoShow = ({
  scheduleTime,
  onSchedule,
}: ScheduleProps): Scheduler => {
  const status = useRef<Status>("idle");

  useMount(() => {
    if (status.current !== "disabled" && status.current !== "scheduled") {
      setTimeout(() => {
        status.current = "scheduled";
        onSchedule();
      }, scheduleTime);
    }
  });

  const disableScheduler = () => (status.current = "disabled");

  return { disableScheduler, status: status.current };
};
